import { useState, useEffect } from "react"
import moment from "moment"
import axios from "axios";
import "./PendingClaims.css"
import toast from "react-hot-toast";
import { IconButton, Modal } from "@mui/material";
import { Eye, X } from "lucide-react";

const PendingClaims = () => {
    const [claims, setClaims] = useState([])
    const [allClaims, setAllClaims] = useState([]);
    const [selectedClaim, setSelectedClaim] = useState(null)
    const [search, setSearch] = useState("")
    const [contentReportsLoaded, setContentReportsLoaded] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [approving, setApproving] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [selectedClaimJson, setSelectedClaimJson] = useState(null)
    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        console.log("claims", claims)
    }, [claims])

    useEffect(() => {
        if (JSON.parse(localStorage.getItem("userData")).id) {
            getPendingClaims();
        }
    }, []);

    const getPendingClaims = async () => {
        const therapistId = JSON.parse(localStorage.getItem("userData")).id;
        const token = JSON.parse(localStorage.getItem("userData")).token;
        axios.defaults.headers.common["Authorization"] = token;

        try {
            const res = await axios.post(window.ajaxLink + "stedi/fetchPendingClaims", { therapistId });
            const data = res.data.responseData?.data || [];

            const parsedData = data.map((claim) => {
                let stediData = {};
                try {
                    stediData = JSON.parse(claim.stedi_claim_json);
                } catch (e) {
                    console.error("Error parsing stedi_claim_json", e);
                }

                const patientName = stediData?.subscriber?.firstName && stediData?.subscriber?.lastName
                    ? `${stediData.subscriber.firstName} ${stediData.subscriber.lastName}`
                    : "Unknown";

                const gender = stediData?.subscriber?.gender === "M" ? "Male" : "Female";



                return {
                    ...claim,
                    patient_name: patientName,
                    gender: gender
                };
            });

            setAllClaims(parsedData);
            setClaims(parsedData);
            setContentReportsLoaded(true);
        } catch (err) {
            console.error(err);
            toast.error("Failed to fetch claims");
            setContentReportsLoaded(true);
        } finally {
            setRefreshing(false)
        }
    };


    useEffect(() => {
        if (search?.length > 2) {
            const filtered = allClaims.filter((claim) =>
                claim.patient_name?.toLowerCase().includes(search.toLowerCase())
            );
            setClaims(filtered);
        } else {
            setClaims(allClaims);
        }
    }, [search, allClaims]);



    const handleApproveClaim = async (claimId) => {
        setApproving(true)
        const therapist = JSON.parse(localStorage.getItem("userData"));
        axios.defaults.headers.common["Authorization"] = therapist.token;
        const therapistSign = `${therapist.first_name} ${therapist.last_name}`;

        try {
            const res = await axios.post(window.ajaxLink + "stedi/approveAndSendClaim", {
                therapistId: therapist.id,
                pendingClaimId: claimId,
                therapistSign: therapistSign
            });

            const msg = res.data.responseData?.data?.message;
            if (msg === "Claim approved and sent") {
                toast.success("Claim approved");
                // Remove from both states
                const updatedClaims = allClaims.filter(c => c.id !== claimId);
                setAllClaims(updatedClaims);
                setClaims(updatedClaims.filter(c =>
                    c.patient_name?.toLowerCase().includes(search.toLowerCase())
                ));
            } else {
                throw new Error(msg)
            }
            setIsModalOpen(false);
            setSelectedClaim(null);
        } catch (err) {
            console.error(err);
            toast.error("Error approving claim");
        } finally {
            setApproving(false)
        }
    };



    const closeModal = () => {
        setIsModalOpen(false)
        setSelectedClaim(null)
    }

    const openInfoModal = (claim) => {
        const data = JSON.parse(claim?.stedi_claim_json)
        setSelectedClaimJson(data)
        setShowInfo(true)
    }

    const closeInfoModal = () => {
        setSelectedClaimJson(null)
        setShowInfo(false)
    }

    return (
        <>
            <div className="dash_box_menu rpt_box_menu" style={{ marginBottom: "10px", gap: "10px", display: 'flex', justifyContent: 'space-between' }}>
                <div className="dash_box_search_hold" style={{ maxWidth: "500px" }}>
                    <input
                        type="text"
                        placeholder="Enter Patient name..."
                        className="dash_box_search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <div className="dash_box_search_icon"></div>
                </div>

                <div className="programs_new_btn top_hold_btn"
                    onClick={async () => {
                        setRefreshing(true);
                        await getPendingClaims()
                    }}
                    style={refreshing || !contentReportsLoaded ?
                        {
                            cursor: 'not-allowed',
                            background: '#9e9e9e'
                        }
                        :
                        {}
                    }>
                    {refreshing ? "Refreshing List..." : "Refresh List"}
                </div>
            </div>


            <div className="table_scrollable_container_new">
                <div className="table_scrollable_inner_container">
                    <div className="programs_table">
                        <div className="programs_cols programs_header_row programs_tbl_row" style={{ border: "none" }}>
                            <div className="programs_col_info">
                                <div className="programs_col_name">Patient</div>
                            </div>
                            <div className="programs_col_info">
                                <div className="programs_col_name">Date</div>
                            </div>
                            <div className="programs_col_info">
                                <div className="programs_col_name">Status</div>
                            </div>
                            <div className="programs_col_info">
                                <div className="programs_col_name">Gender</div>
                            </div>
                            <div className="programs_col_info">
                                <div className="programs_col_name">View Details</div>
                            </div>
                            <div className="programs_col_info" style={{ display: 'flex', justifyContent: 'center' }}>
                                <div className="programs_col_name">Approve Claim</div>
                            </div>
                        </div>
                    </div>
                    <div className="tbl_content_hold" >
                        {contentReportsLoaded && !refreshing ? (
                            claims.length > 0 ? (
                                claims.map((claim) => (
                                    <div key={claim.id} className="programs_tbl_row">
                                        <div className="programs_tbl_col_contain"><div className="programs_tbl_col">{claim.patient_name}</div></div>
                                        <div className="programs_tbl_col_contain"><div className="programs_tbl_col">{moment(claim.created_at || claim.status_updated_at).format("l")}</div></div>
                                        <div className="programs_tbl_col_contain"><div className="programs_tbl_col">{claim.status || "—"}</div></div>
                                        <div className="programs_tbl_col_contain"><div className="programs_tbl_col">{claim.gender || "—"}</div></div>

                                        <div className="programs_tbl_col_contain">
                                            <div className="programs_tbl_col">
                                                <div className="action_btn"
                                                    onClick={() => { openInfoModal(claim) }}
                                                >
                                                    View
                                                </div>
                                            </div>
                                        </div>


                                        <div className="programs_tbl_col_contain" style={{ display: 'flex', justifyContent: 'center' }}>
                                            <div className="programs_tbl_col">
                                                <div className="action_btn" onClick={() => {
                                                    setSelectedClaim(claim);
                                                    setIsModalOpen(true);
                                                }}>
                                                    Approve
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                ))
                            ) : (
                                <div className="no_content_notice_contain">
                                    {search === "" ? (
                                        <div className="programs_no_res_main">No pending claims available</div>
                                    ) : (
                                        <div className="programs_no_res_main">No such patient found in pending claims</div>
                                    )}
                                </div>
                            )
                        ) : (
                            <div className="no_content_notice_contain">
                                <div className="p_load"></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>


            {isModalOpen && selectedClaim && (

                <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                    <div className="dlt_wrapper" style={{ position: "fixed" }}>
                        <div className="dbl_place_on_page">
                            <div
                                className="dlt_surround"
                                style={{
                                    maxWidth: "800px",
                                    width: "max-content",
                                    paddingTop: "30px",
                                    paddingBottom: "30px",
                                    position: "relative",
                                }}
                            >
                                <div className="modal_x_button" onClick={() => setIsModalOpen(false)}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        fill="currentColor"
                                        className="bi bi-x"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </div>
                                <div className="dlt_title">Confirm Approval</div>
                                <div className="dlt_description">
                                    <p> Are you sure you want to approve this claim for <strong>{selectedClaim.patient_name}</strong>?</p>
                                </div>
                                <div className="dlt_exit_btm new_prog_modal_btn_container">
                                    <div
                                        className="dlt_exit_btn dlt_eb_scnd new_prog_modal_btl_style"
                                        style={approving ? { background: '#9e9e9e', color: 'white', cursor: "not-allowed" } : { background: "#166273" }}
                                        onClick={() => handleApproveClaim(selectedClaim.id)}
                                    >
                                        {approving ? "Approving Claim..." : "Yes, Approve"}
                                    </div>
                                    <div
                                        className="dlt_exit_btn dlt_eb_first new_prog_modal_btl_style"
                                        onClick={closeModal}
                                    >
                                        Cancel
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}



            {showInfo && selectedClaimJson && (
                <div className="claim-modal-overlay" onClick={closeInfoModal}>
                    <div className="claim-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="claim-modal-header">
                            <h2>Claim Details</h2>
                            <IconButton onClick={closeInfoModal}>
                                <X />
                            </IconButton>
                        </div>
                        <div className="claim-modal-body">

                            {/* Patient Info */}
                            <div className="claim-modal-section">
                                <h3>Patient Information</h3>
                                <div className="claim-modal-grid">
                                    <div className="claim-modal-field">
                                        <label>Patient Name:</label>
                                        <span>{`${selectedClaimJson?.subscriber?.firstName} ${selectedClaimJson?.subscriber?.lastName}`}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Date of Birth:</label>
                                        <span>{moment(selectedClaimJson?.subscriber?.dateOfBirth, 'YYYYMMDD').format("MMMM Do YYYY")}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Gender:</label>
                                        <span>{selectedClaimJson?.subscriber?.gender}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Member ID:</label>
                                        <span>{selectedClaimJson?.subscriber?.memberId}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Group Number:</label>
                                        <span>{selectedClaimJson?.subscriber?.groupNumber}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Claim Info */}
                            <div className="claim-modal-section">
                                <h3>Claim Information</h3>
                                <div className="claim-modal-grid">
                                    <div className="claim-modal-field">
                                        <label>Claim Filing Code:</label>
                                        <span>{selectedClaimJson?.claimInformation?.claimFilingCode}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Patient Control Number:</label>
                                        <span>{selectedClaimJson?.claimInformation?.patientControlNumber}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Total Charge Amount:</label>
                                        <span>${Number(selectedClaimJson?.claimInformation?.claimChargeAmount).toFixed(2)}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Place of Service Code:</label>
                                        <span>{selectedClaimJson?.claimInformation?.placeOfServiceCode}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Diagnosis Code:</label>
                                        <span>{selectedClaimJson?.claimInformation?.healthCareCodeInformation?.[0]?.diagnosisCode}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Rendering Provider Info */}
                            <div className="claim-modal-section">
                                <h3>Rendering Provider Information</h3>
                                <div className="claim-modal-grid">
                                    <div className="claim-modal-field">
                                        <label>Name:</label>
                                        <span>
                                            {`${selectedClaimJson?.claimInformation?.serviceLines?.[0]?.renderingProvider?.firstName} ${selectedClaim?.claimInformation?.serviceLines?.[0]?.renderingProvider?.lastName}`}
                                        </span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>NPI:</label>
                                        <span>{selectedClaimJson?.claimInformation?.serviceLines?.[0]?.renderingProvider?.npi}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Taxonomy:</label>
                                        <span>{selectedClaimJson?.claimInformation?.serviceLines?.[0]?.renderingProvider?.taxonomyCode}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Service Info */}
                            <div className="claim-modal-section">
                                <h3>Service Information</h3>
                                <div className="claim-modal-grid">
                                    <div className="claim-modal-field">
                                        <label>Service Date:</label>
                                        <span>{moment(selectedClaimJson?.claimInformation?.serviceLines?.[0]?.serviceDate, 'YYYYMMDD').format("MMMM Do YYYY")}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>CPT Code:</label>
                                        <span>{selectedClaimJson?.claimInformation?.serviceLines?.[0]?.professionalService?.procedureCode}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Modifiers:</label>
                                        <span>{selectedClaimJson?.claimInformation?.serviceLines?.[0]?.professionalService?.procedureModifiers?.join(', ')}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Charge Amount:</label>
                                        <span>${Number(selectedClaimJson?.claimInformation?.serviceLines?.[0]?.professionalService?.lineItemChargeAmount).toFixed(2)}</span>
                                    </div>
                                    <div className="claim-modal-field">
                                        <label>Service Units:</label>
                                        <span>{selectedClaimJson?.claimInformation?.serviceLines?.[0]?.professionalService?.serviceUnitCount}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            )}
        </>
    )
}

export default PendingClaims
